import {createSelector} from '@ngrx/store';

import {DISPOSAL_TYPES_FEATURE_KEY, selectMasterDataModuleState} from '../reducers';

export const selectDisposalTypesState = createSelector(
  selectMasterDataModuleState,
  (moduleState) => moduleState[DISPOSAL_TYPES_FEATURE_KEY]
);

export const selectDisposalTypesEntities = createSelector(
  selectDisposalTypesState,
  (state) => state.entities
);

export const selectDisposalTypes = createSelector(
  selectDisposalTypesEntities,
  (entities) => Object.values(entities)
);

export const selectErrors = createSelector(
  selectDisposalTypesState,
  (state) => state.errors
);

export const isLoading = createSelector(
  selectDisposalTypesState,
  (state) => state.loading
);

export const isLoaded = createSelector(
  selectDisposalTypesState,
  (state) => state.loaded
);
